import { createSelector } from 'reselect';
import { IAppState } from '../types/state.d';

export const loadingSelector = (state: IAppState) => state.loading;

type TInFlight = boolean | undefined;

export const getRequestIsInFlight = (state: IAppState, requestName: string) =>
  createSelector(
    loadingSelector,
    (loading): TInFlight =>
      loading[requestName] && loading[requestName].isInFlight,
  )(state);

export const getRequestIsError = (state: IAppState, requestName: string) =>
  createSelector(loadingSelector, loading =>
    Boolean(loading[requestName] && loading[requestName].isError),
  )(state);

export const getRequestIsSuccess = (state: IAppState, requestName: string) =>
  createSelector(loadingSelector, loading =>
    Boolean(loading[requestName] && loading[requestName].isSuccess),
  )(state);
